/**
 * Less rounded house icon with a plus sign inside a square.
 */
export const HousePlusSquareIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.67"
      {...props}
    >
      <path
        d="M1.25024 10L10.0002 1.25L18.7502 10L16.2502 9.99995V19.1666L12.265 19.1666H7.79873L3.75024 19.1666V9.99995L1.25024 10Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M10 10V15" strokeMiterlimit="10" strokeLinecap="round" />
      <path d="M7.5 12.5H12.5" strokeMiterlimit="10" strokeLinecap="round" />
    </svg>
  );
};
